import { ROOT_SLUG } from "./enviroment.ts";

export const BASENAME_ROOT = "/";
const BASENAME_LANDING = "";
// TODO: After account creation a overviewpage const BASENAME_STARTING = "starten";
const BASENAME_SHOP = "anzeigen";
const BASENAME_PRODUCT = "anzeige";
const BASENAME_EDIT_ITEM = `${BASENAME_PRODUCT}/bearbeiten`;
const BASENAME_ADD_ITEM = "inserieren";
const BASENAME_LOGIN = "anmelden";
const BASENAME_REGISTER = "registrieren";
const BASENAME_CHAT = "nachrichten";
const BASENAME_PROFILE = "nutzer";
const BASENAME_EDIT_PROFILE = `${BASENAME_PROFILE}/bearbeiten`;
const BASENAME_ADMIN = "admin";
const BASENAME_SETTING = "mehr";
const BASENAME_VERIFY = "verifizieren";
const BASENAME_ABOUT = "info";
const BASENAME_AUTH = "authentifizieren";
const BASENAME_ADMIN_ITEMS = "items";

export enum AUTH_STATE {
  otp = "otp",
  reset = "reset",
}

// Router paths with parameters
export const ROUTE_LANDING_PATH = BASENAME_LANDING;
export const ROUTE_SHOP_PATH = `${BASENAME_SHOP}/:category?/*?`;
export const ROUTE_EDIT_ITEM_PATH = `${BASENAME_EDIT_ITEM}/:itemId/:categoryId`;
export const ROUTE_ADD_ITEM_PATH = `${BASENAME_ADD_ITEM}/:category?/:itemId?`;
export const ROUTE_PRODUCT_PATH = `${BASENAME_PRODUCT}/:id`;
export const ROUTE_LOGIN_PATH = BASENAME_LOGIN;
export const ROUTE_REGISTER_PATH = BASENAME_REGISTER;
export const ROUTE_CHAT_PATH = `${BASENAME_CHAT}`;
export const ROUTE_IN_CHAT_PATH = `${BASENAME_CHAT}/:chatId`;
export const ROUTE_EDIT_PROFILE_PATH = BASENAME_EDIT_PROFILE;
export const ROUTE_PROFILE_PATH = `${BASENAME_PROFILE}/:id`;
export const ROUTE_ADMIN_PATH = `${BASENAME_ADMIN}/`;
export const ROUTE_ADMIN_ITEM_PATH = `${BASENAME_ADMIN_ITEMS}/:id?`;
export const ROUTE_ADMIN_REPORT_PATH = `reports`;
export const ROUTE_ADMIN_CATEGORY_PATH = `category/:category`;
export const ROUTE_ADMIN_FILTER_PATH = `filter`;
export const ROUTE_ADMIN_USERS_PATH = `users`;
export const ROUTE_SETTING_PATH = `${BASENAME_SETTING}/`;
export const ROUTE_VERIFY_PATH = `${BASENAME_VERIFY}/:state?`;
export const ROUTE_ABOUT_PATH = BASENAME_ABOUT;
export const ROUTE_AUTH_PATH = (state?: AUTH_STATE) =>
  `${BASENAME_AUTH}/${state || ""}`;

// Navigation builders
export const ROUTE_LANDING = `${BASENAME_ROOT}${BASENAME_LANDING}`;
export const ROUTE_ABOUT = `${BASENAME_ROOT}${BASENAME_ABOUT}`;
export const ROUTE_SHOP = (category?: string) =>
  `${BASENAME_ROOT}${BASENAME_SHOP}${category ? "/" + category : ""}`;

export const ROUTE_EDIT_ITEM = (product?: string, category?: string) =>
  `${BASENAME_ROOT}${BASENAME_EDIT_ITEM}/${product}/${category ?? ROOT_SLUG}`;

export const ROUTE_ADD_ITEM = (category?: string, item?: string) =>
  `${BASENAME_ROOT}${BASENAME_ADD_ITEM}${category ? "/" + category : ""}${item ? "/" + item : ""}`;

export const ROUTE_PRODUCT = (id: string) => `/${BASENAME_PRODUCT}/${id}`;

export const ROUTE_LOGIN = `${BASENAME_ROOT}${BASENAME_LOGIN}`;
export const ROUTE_REGISTER = `${BASENAME_ROOT}${BASENAME_REGISTER}`;
export const ROUTE_CHAT = (chatId?: string) =>
  `${BASENAME_ROOT}${BASENAME_CHAT}${chatId ? `/${chatId}` : ""}`;

export const ROUTE_EDIT_PROFILE = `${BASENAME_ROOT}${BASENAME_EDIT_PROFILE}`;

export const ROUTE_PROFILE = (id?: string) =>
  `${BASENAME_ROOT}${BASENAME_PROFILE}/${id}`;

export const ROUTE_ADMIN = `${BASENAME_ROOT}${ROUTE_ADMIN_PATH}`;
export const ROUTE_ADMIN_CATEGORY = (category?: string) =>
  `${BASENAME_ROOT}${ROUTE_ADMIN_PATH}/category/${category ? `${category}` : ROOT_SLUG}`;
export const ROUTE_ADMIN_ITEM = (itemId: string) =>
  `${ROUTE_ADMIN}/${BASENAME_ADMIN_ITEMS}/${itemId}`;
export const ROUTE_SETTING = `${BASENAME_ROOT}${BASENAME_SETTING}`;

export type ROUTE_VERIFY_STATE = "validate" | "otp_invalid";
export const ROUTE_VERIFY = (state?: ROUTE_VERIFY_STATE) =>
  `${BASENAME_ROOT}${BASENAME_VERIFY}/${state || ""}`;

export const ROUTE_AUTH = (state: AUTH_STATE) =>
  `${BASENAME_ROOT}${BASENAME_AUTH}/${state}`;
